export const LOADING_CYCLE_MS = 3000;

export function delayToCycleEnd(elapsed: number): number {
	const cycles = Math.max(1, Math.ceil(elapsed / LOADING_CYCLE_MS));
	return Math.max(0, cycles * LOADING_CYCLE_MS - elapsed);
}

// Lottie plays at 1.5x; seek to the current cycle instead of replaying a late burst.
export function confettiPlaybackTime(elapsed: number, duration: number): number | null {
	const time = ((Math.max(0, elapsed) % LOADING_CYCLE_MS) - 1680) * 1.5;
	return time >= 0 && time < duration ? time : null;
}
